<template>
  <div>
    <vehicle-list :organization-id="organization?.id" :organization-name="organization?.name" />
  </div>
</template>

<script>
import VehicleList from "@/components/elements/VehicleList.vue";

export default {
  name: "OrganizationVehicles",
  components: { VehicleList },

  computed: {
    organization() {
      return this.$parent.organization ?? null
    },
  },
}
</script>

<style lang="scss">
</style>
